<template>
  <section class="content-width">
    <!-- <notice href="/services">
      Not sure what any of this stuff means? Check out the Services page!
    </notice> -->

    <h2>Computer Languages</h2>
    <ul>
      <li><a href="https://www.cplusplus.com" target="_blank">C/C++</a></li>
      <li><a href="https://www.rust-lang.org/" target="_blank">Rust</a></li>
      <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target="_blank">JavaScript</a></li>
      <li><a href="https://developer.mozilla.org/en-US/docs/Web/HTML" target="_blank">HTML</a></li>
      <li><a href="https://developer.mozilla.org/en-US/docs/Web/CSS" target="_blank">CSS</a></li>
      <li><a href="https://sass-lang.com" target="_blank">SASS</a></li>
      <li><a href="https://swift.org" target="_blank">Swift</a></li>
    </ul>

    <h2>Systems</h2>
    <ul>
      <li><a href="https://nodejs.org" target="_blank">Node.js</a></li>
      <li><a href="https://developer.apple.com/ios/" target="_blank">iOS</a></li>
      <li><a href="https://developer.android.com" target="_blank">Android</a></li>
      <li><a href="https://developer.apple.com/macos/" target="_blank">macOS</a></li>
      <li><a href="https://www.linuxfoundation.org" target="_blank">Linux</a></li>
      <li><a href="https://www.microsoft.com/en-us/windows" target="_blank">Windows</a></li>
      <li><a href="https://www.mongodb.com" target="_blank">MongoDB</a></li>
    </ul>

    <h2>Frameworks</h2>
    <ul>
      <li><a href="https://vuejs.org" target="_blank">Vue.js</a></li>
      <li><a href="https://www.babylonjs.com" target="_blank">Babylon.js</a></li>
      <li><a href="https://github.com/jeromeetienne/AR.js" target="_blank">AR.js</a></li>
      <li><a href="https://aframe.io" target="_blank">A-Frame</a></li>
      <li><a href="https://www.8thwall.com" target="_blank">8thwall</a></li>
      <li><a href="https://koajs.com" target="_blank">Koa.js</a></li>
      <li><a href="https://handlebarsjs.com" target="_blank">Handlebars</a></li>
      <li><a href="https://jquery.com" target="_blank">jQuery</a></li>
      <li><a href="https://github.com/marty-suzuki/MisterFusion" target="_blank">MisterFusion</a></li>
      <li><a href="https://github.com/mxcl/PromiseKit" target="_blank">PromiseKit</a></li>
      <li><a href="https://mongoosejs.com" target="_blank">Mongoose</a></li>
      <li><a href="https://www.unrealengine.com/" target="_blank">Unreal Engine</a></li>
    </ul>

    <h2>Tools</h2>
    <ul>
      <li><a href="https://git-scm.com" target="_blank">Git</a></li>
      <li><a href="https://developer.apple.com/xcode/" target="_blank">Xcode</a></li>
      <li><a href="https://parceljs.org" target="_blank">Parcel</a></li>
      <li><a href="https://webpack.js.org" target="_blank">Webpack</a></li>
      <li><a href="https://cocoapods.org" target="_blank">CocoaPods</a></li>
    </ul>

    <h2>Services</h2>
    <ul>
      <li><a href="https://azure.microsoft.com/" target="_blank">Azure</a></li>
      <li><a href="https://auth0.com" target="_blank">Auth0</a></li>
      <li><a href="https://www.twilio.com" target="_blank">Twilio</a></li>
    </ul>

    <h2>Design &amp; Media</h2>
    <ul>
      <li><a href="https://www.apple.com/final-cut-pro/" target="_blank">Final Cut Pro X</a></li>
      <li><a href="https://www.adobe.com/products/premiere.html" target="_blank">Premiere Pro</a></li>
    </ul>

    <h2>Human Languages</h2>
    <ul>
      <li>English</li>
      <li>Ukrainian</li>
      <li>Russian</li>
    </ul>
  </section>
</template>

<script>
import Notice from '@/components/Notice.vue';

export default {
  // components: { Notice },
};
</script>

<style lang="scss" scoped>
@import '@/styles/sizes.scss';

ul {
  display: grid;
  margin: 4px 0 48px;
  padding: 0;
  grid-template-columns: repeat(4, 192px);
  grid-auto-flow: row dense;
  list-style: none;

  @include break-tablet {
    grid-template-columns: repeat(3, 156px);
  }

  @include break-phone {
    grid-template-columns: repeat(2, 136px);
  }
  
  li {
    margin: 6px 0;
    padding: 0;
  }
}
</style>
